export const PREVIEW = 0
export const LEARN = 5
export const TEACH = 10
export const DESIGN = 15

export const PATH_MODE_LABELS = {
  [PREVIEW]: "preview",
  [LEARN]: "learn",
  [TEACH]: "teach",
  [DESIGN]: "design"
}

export const STEP_TYPES = [
  {
    type: "video",
    verb: "watch",
    prompt: "Enter video title",
    examples: "a lecture, demo, video..."
  },
  {
    type: "reading",
    verb: "read",
    prompt: "Enter reading title",
    examples: "an article, book chapter, tutorial..."
  },
  {
    type: "assessment",
    verb: "take",
    prompt: "Enter assessment title...",
    examples: "a quiz, test, survey..."
  },
  {
    type: "submission",
    verb: "submit",
    prompt: "Enter what to submit",
    examples: "a project, paper, journal...",
    allow_manual_completion: false,
    requires_grading: true
  },
  {
    type: "event",
    verb: "attend",
    prompt: "Enter event title",
    examples: "a class, live stream, event..."
  },
  {
    type: "audio",
    verb: "listen",
    prompt: "Enter audio title",
    examples: "a lecture, podcast, audio..."
  },
  {
    type: "completion",
    verb: "to-do",
    prompt: "Enter task",
    examples: "a discussion, task, anything..."
  }
]
